import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Michael Irigoyen
 * id 0EA34D8C-1A02-4A92-8293-991702ABD065
 * name circle-small
 * version: 2.5.94
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/circle-small.svg
 * tags
 * - Math 
 */
export const CircleSmallIcon = createSvgIcon(<><path d="M12,10A2,2 0 0,0 10,12C10,13.11 10.9,14 12,14C13.11,14 14,13.11 14,12A2,2 0 0,0 12,10Z" /></>, 'CircleSmallIcon');
export default CircleSmallIcon